/** i18next instance for admin-web, bound to react-i18next + @gym/i18n catalogs. */
import { buildI18nConfig } from '@gym/i18n';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init(buildI18nConfig('mk'));
}

export { i18next };
